import { render, staticRenderFns } from "./HomeBase.vue?vue&type=template&id=64348a1c&scoped=true&"
import script from "./HomeBase.vue?vue&type=script&lang=js&"
export * from "./HomeBase.vue?vue&type=script&lang=js&"
import style0 from "./HomeBase.vue?vue&type=style&index=0&id=64348a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64348a1c",
  null
  
)

export default component.exports